export default "__VITE_ASSET__179d9e57__"